export function getFoodTypeLabel(t, foodType) {
  switch (foodType) {
    case 'prepared':
      return t('data.food-types.prepared');
    case 'prepared-pickup-temp':
      return t('data.food-types.prepared-pickup-temp');
    case 'prepared-dropoff-temp':
      return t('data.food-types.prepared-dropoff-temp');
    case 'non-perishable':
      return t('data.food-types.non-perishable');
    case 'dairy':
      return t('data.food-types.dairy');
    case 'dairy-pickup-temp':
      return t('data.food-types.dairy-pickup-temp');
    case 'dairy-dropoff-temp':
      return t('data.food-types.dairy-dropoff-temp');
    case 'produce':
      return t('data.food-types.produce');
    case 'produce-pickup-temp':
      return t('data.food-types.produce-pickup-temp');
    case 'produce-dropoff-temp':
      return t('data.food-types.produce-dropoff-temp');
    case 'meat':
      return t('data.food-types.meat');
    case 'meat-pickup-temp':
      return t('data.food-types.meat-pickup-temp');
    case 'meat-dropoff-temp':
      return t('data.food-types.meat-dropoff-temp');
    case 'baked':
      return t('data.food-types.baked');
    case 'beverages':
      return t('data.food-types.beverages');
    case 'frozen':
      return t('data.food-types.frozen');
    case 'non-food':
      return t('data.food-types.non-food');
    case 'compost':
      return t('data.food-types.compost');
    case 'unusable':
      return t('data.food-types.unusable');
    case 'animal-feed':
      return t('data.food-types.animal-feed');
    case 'total-food':
      return t('data.food-types.total-food');
    default:
      throw new Error(`Unknown food type: ${foodType}`);
  }
}
